/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  app.ImageView = app.View.extend({
    events: {
      'click': 'showImagePopup',
      'mouseover': 'showImageZoom',
      'mouseout': 'mouseOut'
    },
    
    showImagePopup: function (e) {
      e.preventDefault();
      if (!$(e.currentTarget).data('popup')) {
        return;
      }
      new app.ImagePopupView({
        imageUrl: $(e.currentTarget).data('imgbox-on'),
        alt: $(e.currentTarget).attr('alt')
      });
    },
    
    showImageZoom: function (e) {
      var target = e.currentTarget;
      if (!$(target).data('zoom')) {
        return;
      }
      var offset = $(target).offset();
      offset.top += target.height / 2;
      offset.left += target.width;
      
      new app.ImagePopupView({
        imageUrl: $(target).attr('src'),
        alt: $(target).attr('alt'),
        zoom: true,
        parent: this,
        offset: offset
      });
    },
    
    mouseOut: function () {
      this.trigger('mouseout');
    }
  });
})(jQuery);

}.call(window));